import {customElement, bindable} from 'aurelia-framework';
import * as _ from 'lodash';

@customElement('sio-log-footer')
export class LogFooter
{
    @bindable log;
}

